module.exports = {
      id: "story-play-usage",
      viewBox: "0 0 35 35",
      url: __webpack_public_path__ + "svg-sprite-3f41b5422aa8d7a50bd372d0b736cd55.svg#story-play",
      toString: function () {
        return this.url;
      }
    }